import { EnvConfig } from '@shared/definitions';

export const environment: EnvConfig = {
  featureFlags: {},
  production: false,
  staging: true,
  development: false,
  api: 'https://pauly-staging.azurewebsites.net',
  facebookAppId: '',
  instrumentationKey: '',
  recaptchaSiteKey: '',
};
